import instance from "./axios";

export async function getNBKtoken(idEdifice: string, origin: string) {
  // console.log("🚀 ~ getNBKtoken ~ idEdifice:", idEdifice);
  try {
    const res = await instance.post(
      `/main/edifice/token`,
      {
        idEdifice,
        origin,
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return res.data;
  } catch (e) {
    console.log(`[getNBKToken] Il y a eu un problème : ${e}`);
    return null;
  }
}

export async function getNBKtokenFromCode(code: string, origin: string) {
  // console.log("🚀 ~ getNBKtokenFromCode ~ code:", code);
  try {
    const res = await instance.post(
      `/main/edifice/token/code`,
      {
        code,
        origin,
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return res.data;
  } catch (e) {
    console.log(`[getNBKtokenFromCode] Il y a eu un problème : ${e}`);
    return null;
  }
}

export async function getTeacherClasses() {
  try {
    const res = await instance.get(`/main/edifice/teacher/classes`, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return res.data;
  } catch (e) {
    console.log(`[getTeacherClasses] Il y a eu un problème : ${e}`);
    return null;
  }
}

export async function getStudentCode() {
  try {
    const res = await instance.get(`/main/edifice/code`, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return res.data;
  } catch (e) {
    console.log(`[getTeacherClasses] Il y a eu un problème : ${e}`);
    return null;
  }
}
